import "./App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import NotFound from "./pages/NotFound";
import redirects from "./seo/redirects.json";
import { ScrollToTop } from "./components/ScrollToTop";
const Home = lazy(() => import("./pages/Home"));
const Europe = lazy(() => import("./pages/Europe"));
const Escape = lazy(() => import("./pages/Escape"));
const Admin = lazy(() => import("./pages/Admin"));
const TermsPage = lazy(() => import("./pages/Terms"));
const Landing = lazy(() => import("./pages/Landing"));
const Press = lazy(() => import("./pages/Press"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const Reviews = lazy(() => import("./pages/Reviews"));
const DJPage = lazy(() => import("./pages/DJPage"));

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={<div className="min-h-screen bg-[#0A0A0A]" />}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/press" element={<Press />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/getaway" element={<Home />} />
          <Route path="/europe" element={<Europe />} />
          <Route path="/escape" element={<Escape />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/djs/:slug" element={<DJPage />} />
          {Object.entries(redirects).map(([from, to]) => (
            <Route key={from} path={from} element={<Navigate to={to} replace />} />
          ))}
          <Route path="*" element={<NotFound />} />
        </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
